import { render, staticRenderFns } from "./video-screen-recording.vue?vue&type=template&id=48c605a6&scoped=true"
import script from "./video-screen-recording.vue?vue&type=script&lang=js"
export * from "./video-screen-recording.vue?vue&type=script&lang=js"
import style0 from "./video-screen-recording.vue?vue&type=style&index=0&id=48c605a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c605a6",
  null
  
)

export default component.exports